module.exports = __webpack_public_path__ + "img/trophy3.png";